import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, OnInit, HostListener
} from '@angular/core';


@Component({
	selector: 'ad-admin-dialog',
	templateUrl: './ad-admin-dialog.component.html',
	styleUrls: ['./ad-admin-dialog.component.scss']
})
export class AdAdminDialogComponent implements OnChanges {

	@Input()
	public display: boolean = false;

	@Input()
	public messageType: string = "";

	@Input()
	public domains: string[] = [];

	@Output()
	public displayChange = new EventEmitter();

	@Output()
	public onOk = new EventEmitter();

	@Output()
	public onCancel = new EventEmitter();

	public username: string = "";
	public password: string = "";
	public domain: string = "";

	private buttonClicked: boolean = false;

	constructor() {
		return;
	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.username = "";
		this.password = "";

		if (this.domains.length > 0) {
			this.domain = this.domains[0];
		}
		else {
			this.domain = "";
		}
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public get enableOk(): boolean {
		return (!!this.username && !!this.password && !!this.domain);
	}

	public cancel(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hideDialog();
		this.onCancel.emit();
		this.password = "";
	}

	public ok(): void {
		this.buttonClicked = true;
		this.hideDialog();
		this.onOk.emit({
			username: this.username,
			password: this.password,
			domain: this.domain
		});
		this.password = "";
	}

	public displayDialog() {
		this.display = true;
		this.displayChange.emit();
    }

    public hideDialog() {
		this.display = false;
		this.displayChange.emit();
	}

	@HostListener('window:keyup', ['$event'])
	public loginOnEnter(event: KeyboardEvent): void {
		if (this.enableOk) {
			if (event.keyCode === 13) {
				this.ok();
			}
		}
	}

}
